/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {OfferCatalogBlock} from "./offerCatalogBlock.zod";
import {OfferRichTextBlock} from "./offerRichTextBlock.zod";

export const OfferBlock = zod.union([OfferRichTextBlock, OfferCatalogBlock]);

export type OfferBlock = zod.input<typeof OfferBlock>;
export type OfferBlockOutput = zod.output<typeof OfferBlock>;
